import { useSelector } from 'react-redux'
import Step from '../../enums/Step'
import type { RootState } from '../../store/store'
import CustomerInfoTab from '../CustomerInfoTab/CustomerInfoTab'
import DatesTab from '../DatesTab/DatesTab'
import FinalTab from '../FinalTab/FinalTab'
import VehicleTab from '../VehicleTab/VehicleTab'
import styles from './TabContent.module.scss'
import ReviewRezTab from '../ReviewRezTab/ReviewRezTab'

const TabContent = (): any => (
  <div className={styles.TabContent} data-testid='TabContent'>
    {renderSwitch()}
  </div>
)

function renderSwitch(): any {
  const rezCurrentStep = useSelector((state: RootState) => state.reservationSlice.rezCurrentStep)
  switch (rezCurrentStep?.stepId) {
    case Step.One:
      return <DatesTab />
    case Step.Two:
      return <VehicleTab />
    case Step.Three:
      return <CustomerInfoTab />
    case Step.Four:
      return <div>COMPONENT FOR STEP FIVE</div>
    case Step.Five:
      return <ReviewRezTab />
    case Step.Six:
      return <FinalTab />
    default:
      return <FinalTab />
  }
}

export default TabContent
